import React from "react";
import EditAgent from "../../amakkn/agents/edit-agent";

function WLEditAgent() {
  return <EditAgent />;
}

export default WLEditAgent;
